export default [
  {
    path: 'afiliados/links',
    name: 'links',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Links',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Links' },
      ]
    }
  },
]